import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import moment, { invalid } from "moment";
import DateTime from 'react-datetime'
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";
import { canEdit } from "../../../../utils/modulePermissions";
import CardLessDataTableWithOutSearch from '../../datatables/CardLessDataTableWithOutSearch';
import { FeeTableShimmer } from '../FeeShimmer';

// /Fee-Structure/* → "Fee_Structure". Match on module_key only.
//
// This modal sends fee-status notifications to parents — a real outbound side effect. It
// is currently UNREACHABLE (feeDashBoardSection never sets notificationModal to true), so
// this is a backstop, not a live gate: it uses the SILENT canEdit() rather than
// requireEdit(), because there is no opener to raise a modal from and no Access Denied
// modal rendered here. If the trigger is ever re-enabled, gate that opener too.
const FEE_STRUCTURE_MODULE = ["Fee_Structure"];


const SEND_NOTIFICATION = gql`
  mutation($params: EducationNotifications) {
    sendEduNotification(params: $params)
  }`

class NotificationModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loadingSpinner: 0,
            currentStep: 1,
            submitError: "",
            isSubmitting: false,
        }
    }

    handleFormSubmit = async () => {
        this.setState({
            isSubmitting: true
        })
        let params = {
            notification_type: "fee",
            institute_id: parseInt(Cookies.get("institutionid")),
            branch_id: this.props.stateData.branch,
            term_no: parseInt(this.props.stateData.selectedTerm),
            template_name: "Fee Status",
        }


        this.setState({
            loadingSpinner: 1,
        });

        this.sendEduNotification(params).catch(error => {
            this.setState({ submitError: error.graphQLErrors.map(x => x.message), loadingSpinner: 0 })
            setTimeout(() => {
                this.props.onHide();
            }, 5000);
        })
    }

    // Last gate before sendEduNotification leaves the client.
    sendEduNotification = async params => {
        if (!canEdit(FEE_STRUCTURE_MODULE)) return;

        await this.props.sendEduNotification({
            variables: {
                params
            },
            update: (store, { data }) => {
                if (data.sendEduNotification) {
                    this.setState({
                        loadingSpinner: 0,
                        currentStep: 5,
                    });
                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }
            }
        });
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
        this.props.onHide();
    };

    sortFunc(a, b, order, dataField, rowA, rowB) {
        if (order === 'asc') return parseInt(a) - parseInt(b);
        else return parseInt(b) - parseInt(a);
    }

    sortFuncdate(a, b, order) {

        const dateStr = a;
        const [day, month, year] = dateStr.split('/');
        const timestamp = new Date(year, month - 1, day).getTime() / 1000;

        const dateStrtwo = b
        const [day1, month1, year1] = dateStrtwo.split('/');
        const timestamp2 = new Date(year1, month1 - 1, day1).getTime() / 1000;

        if (order === 'asc') return parseInt(timestamp) - parseInt(timestamp2);
        else return parseInt(timestamp2) - parseInt(timestamp);

    }

    Columns(data) {
        let Columns = [
            {
                dataField: "student_name",
                text: "Student name",
            },
            {
                dataField: "parent_mobile",
                text: "Parent mobile",
            },
            {
                dataField: "term_amount",
                text: "Pending Amount",
                sortFunc: this.sortFunc.bind(this),
                sort: true
            },
            {
                dataField: "term_date",
                text: "Last Date",
                sortFunc: this.sortFuncdate.bind(this),
                sort: true

            },
        ];
        return Columns;
    }

    render() {

        const styles = {
            cursor: this.state.isSubmitting ? "not-allowed" : "pointer",
            backgroundColor: "#7c3aed",
            borderColor: "#7c3aed",
            color: "#ffffff",
            borderRadius: "10px",
            fontWeight: "600",
            fontSize: "13px",
            padding: "10px 24px",
            width: "auto",
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            boxShadow: "0 4px 12px rgba(124, 58, 237, 0.15)",
            transition: "all 0.2s ease",
        };


        return (
            <Modal
                {...this.props}
                size="md"
                aria-labelledby="example-modal-sizes-title-lg"
                className="notify_modal"
            >
                <Modal.Header closeButton style={{ background: '#ffffff', borderBottom: '1px solid #f1f5f9', padding: '20px 24px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                        <div style={{
                            width: 38,
                            height: 38,
                            borderRadius: 10,
                            background: '#fee2e2',
                            border: '1px solid #fecaca',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#dc2626',
                            fontSize: 16,
                            flexShrink: 0
                        }}>
                            <i className="fal fa-bell-exclamation" />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
                            <Modal.Title style={{ color: '#0f172a', fontWeight: 700, fontSize: 16, margin: 0, letterSpacing: '-0.01em' }}>
                                Term {this.props.stateData.selectedTerm} Pending Students
                            </Modal.Title>
                            <span style={{ color: '#64748b', fontSize: 12, fontWeight: 500, marginTop: 2 }}>Review students with overdue/pending fees for this term</span>
                        </div>
                    </div>
                </Modal.Header>


                {
                    this.props.stateData.loaderforModal == 1 ?
                        (
                            <Modal.Body className="p-1">
                                <FeeTableShimmer rows={6} cols={6} />
                            </Modal.Body>
                        )
                        :
                        (
                            <>
                                <Modal.Body className="p-1">
                                    <CardLessDataTableWithOutSearch
                                        parentData={this.props.stateData.getTermWisePendingStudents}
                                        particlecolumns={this.Columns()}
                                    />
                                </Modal.Body>

                                <Modal.Footer style={{ background: '#ffffff', borderTop: '1px solid #f1f5f9', padding: '16px 24px' }}>
                                    <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
                                        {this.state.submitError && (
                                            <div style={{ color: "#dc2626", fontSize: 13, fontWeight: 600 }}>
                                                <i className="fal fa-exclamation-circle" style={{ marginRight: 6 }} />
                                                {this.state.submitError}
                                            </div>
                                        )}
                                        {this.state.currentStep == 5 && (
                                            <div style={{ color: "#16a34a", fontSize: 13, fontWeight: 600 }}>
                                                <i className="fal fa-check-circle" style={{ marginRight: 6 }} />
                                                Notification sent successfully
                                            </div>
                                        )}
                                        <Button style={styles} onClick={(e) => this.handleFormSubmit()}>
                                            {this.state.loadingSpinner == 1 ? (
                                                <span className="spinner-border spinner-border-sm" style={{ marginRight: 6 }}></span>
                                            ) : (
                                                <i className="fal fa-paper-plane" />
                                            )}
                                            Send Notification
                                        </Button>
                                    </div>
                                </Modal.Footer>
                            </>
                        )
                }
            </Modal>
        )
    }
}


export default withRouter(withApollo(compose(
    graphql(SEND_NOTIFICATION, {
        name: "sendEduNotification"
    })
)(NotificationModal)));